"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
var vue_1 = require("vue");
var PreferencesManager_1 = require("./PreferencesManager");
var constants_1 = require("../constants");
var PartyName_1 = require("../turmoil/parties/PartyName");
var GameSetupDetail_1 = require("./GameSetupDetail");
var TranslateMixin_1 = require("./TranslateMixin");
var GlobalParameterValue_1 = require("./GlobalParameterValue");
var MoonGlobalParameterValue_1 = require("./MoonGlobalParameterValue");
var GlobalParameter_1 = require("../GlobalParameter");
var PreferencesDialog_1 = require("./PreferencesDialog");
exports.Sidebar = vue_1.default.component('sidebar', {
    props: {
        playerNumber: {
            type: Number,
        },
        gameOptions: {
            type: Object,
        },
        acting_player: {
            type: Boolean,
        },
        player_color: {
            type: String,
        },
        generation: {
            type: Number,
        },
        coloniesCount: {
            type: Number,
        },
        temperature: {
            type: Number,
        },
        oxygen: {
            type: Number,
        },
        oceans: {
            type: Number,
        },
        venus: {
            type: Number,
        },
        moonData: {
            type: Object,
        },
        turmoil: {
            type: Object || undefined,
        },
        lastSoloGeneration: {
            type: Number,
        },
        spectatorMode: {
            type: Boolean,
        },
    },
    components: {
        'game-setup-detail': GameSetupDetail_1.GameSetupDetail,
        'global-parameter-value': GlobalParameterValue_1.GlobalParameterValue,
        'moon-global-parameter-value': MoonGlobalParameterValue_1.MoonGlobalParameterValue,
        'preferences-dialog': PreferencesDialog_1.PreferencesDialog,
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    data: function () {
        return {
            'ui': {
                'preferences_panel_open': false,
                'gamesetup_detail_open': false,
            },
            'hide_hand': false,
            'hide_awards_and_milestones': false,
            'hide_top_bar': false,
            'small_cards': false,
            'remove_background': false,
            'magnify_cards': true,
            'show_alerts': true,
            'lang': 'en',
            'langs': constants_1.LANGUAGES,
            'enable_sounds': false,
            'hide_tile_confirmation': false,
            'show_card_number': false,
            'hide_discount_on_cards': false,
            'learner_mode': true,
            'hide_animated_sidebar': false,
            'hide_color_code_buttons': false,
            'spectator_tab': 'board',
            'spectator_pause': false,
            'globalParameter': GlobalParameter_1.GlobalParameter,
        };
    },
    methods: {
        getPlayerColorCubeClass: function () {
            return this.acting_player && (PreferencesManager_1.PreferencesManager.loadBoolean('hide_animated_sidebar') === false) ? 'preferences_player_inner active' : 'preferences_player_inner';
        },
        getSideBarClass: function () {
            return this.acting_player && (PreferencesManager_1.PreferencesManager.loadBoolean('hide_animated_sidebar') === false) ? 'preferences_acting_player' : 'preferences_nonacting_player';
        },
        getGenMarker: function () {
            return "" + this.generation;
        },
        rulingPartyToCss: function () {
            if (this.turmoil.ruling === undefined) {
                console.warn('no party provided');
                return '';
            }
            return this.turmoil.ruling.toLowerCase().split(' ').join('_');
        },
        getRulingParty: function () {
            var rulingPartyName = this.turmoil.ruling;
            if (rulingPartyName === PartyName_1.PartyName.MARS) {
                return 'Mars';
            }
            else if (rulingPartyName === PartyName_1.PartyName.SCIENTISTS) {
                return 'Science';
            }
            else if (rulingPartyName === PartyName_1.PartyName.KELVINISTS) {
                return 'Kelvin';
            }
            else {
                return rulingPartyName;
            }
        },
        toggleSpectatorPlayPause: function () {
            PreferencesManager_1.PreferencesManager.save('spectator_pause', !this.isSpectatorPaused(), true);
            window.location.reload();
        },
        isSpectatorPaused: function () {
            return PreferencesManager_1.PreferencesManager.loadBoolean('spectator_pause');
        },
    },
    template: "\n<div :class=\"'sidebar_cont sidebar '+getSideBarClass()\">\n  <div class=\"tm\">\n    <div class=\"gen-text\">GEN</div>\n    <div class=\"gen-marker\">{{ getGenMarker() }}</div>\n  </div>\n  <div v-if=\"gameOptions.turmoilExtension\">\n    <div :class=\"'party-name party-name-indicator party-name--'+rulingPartyToCss()\"> {{ getRulingParty() }}</div>\n  </div>\n  <div class=\"global_params\">\n    <global-parameter-value :param=\"this.globalParameter.TEMPERATURE\" :value=\"this.temperature\"></global-parameter-value>\n    <global-parameter-value :param=\"this.globalParameter.OXYGEN\" :value=\"this.oxygen\"></global-parameter-value>\n    <global-parameter-value :param=\"this.globalParameter.OCEANS\" :value=\"this.oceans\"></global-parameter-value>\n    <global-parameter-value v-if=\"gameOptions.venusNextExtension\" :param=\"this.globalParameter.VENUS\" :value=\"this.venus\"></global-parameter-value>\n    <moon-global-parameter-value v-if=\"gameOptions.moonExpansion\" :moonData=\"this.moonData\"></moon-global-parameter-value>\n  </div>\n\n  <div v-if=\"!spectatorMode\" class=\"sidebar_item preferences_player\">\n    <div :class=\"getPlayerColorCubeClass()+' player_bg_color_' + player_color\"></div>\n  </div>\n\n  <a v-if=\"!spectatorMode\" href=\"#board\">\n      <div class=\"sidebar_item sidebar_item_shortcut\">\n          <i class=\"sidebar_icon sidebar_icon--board\"></i>\n      </div>\n  </a>\n  <a v-if=\"!spectatorMode\" href=\"#actions\">\n      <div class=\"sidebar_item sidebar_item_shortcut\">\n          <i class=\"sidebar_icon sidebar_icon--actions\"></i>\n      </div>\n  </a>\n  <a href=\"#cards\">\n      <div class=\"sidebar_item goto-cards sidebar_item_shortcut\">\n          <i class=\"sidebar_icon sidebar_icon--cards\"><slot></slot></i>\n      </div>\n  </a>\n  <a v-if=\"coloniesCount > 0 && !spectatorMode\" href=\"#colonies\">\n      <div class=\"sidebar_item sidebar_item_shortcut\">\n          <i class=\"sidebar_icon sidebar_icon--colonies\"></i>\n      </div>\n  </a>\n  <div v-if=\"spectatorMode\" class=\"sidebar_item\" v-on:click=\"toggleSpectatorPlayPause()\">\n    <div class=\"sidebar_icon play_button\">\n      <i v-if=\"isSpectatorPaused()\" class=\"material-icons\">play_arrow</i>\n      <i v-else class=\"material-icons\">pause</i>\n    </div>\n  </div>\n\n  <div class=\"sidebar_item sidebar_item--info\">\n    <i class=\"sidebar_icon sidebar_icon--info\"\n      :class=\"{'sidebar_item--is-active': ui.gamesetup_detail_open}\"\n      v-on:click=\"ui.gamesetup_detail_open = !ui.gamesetup_detail_open\"\n      :title=\"$t('game setup details')\"></i>\n    <div class=\"info_panel\" v-if=\"ui.gamesetup_detail_open\">\n      <div class=\"info_panel-spacing\"></div>\n      <div class=\"info-panel-title\" v-i18n>Game Setup Details</div>\n      <game-setup-detail :gameOptions=\"gameOptions\" :playerNumber=\"playerNumber\" :lastSoloGeneration=\"lastSoloGeneration\"></game-setup-detail>\n\n      <div class=\"info_panel_actions\">\n        <button class=\"btn btn-lg btn-primary\" v-on:click=\"ui.gamesetup_detail_open=false\">Ok</button>\n      </div>\n    </div>\n  </div>\n\n  <a href=\"/help\" target=\"_blank\">\n    <div class=\"sidebar_item sidebar_item--help\">\n      <i class=\"sidebar_icon sidebar_icon--help\" :title=\"$t('player aid')\"></i>\n    </div>\n  </a>\n\n  <div class=\"sidebar_item sidebar_item--settings\">\n    <i class=\"sidebar_icon sidebar_icon--settings\" :class=\"{'sidebar_item--is-active': ui.preferences_panel_open}\" v-on:click=\"ui.preferences_panel_open = !ui.preferences_panel_open\"></i>\n    <preferences-dialog v-show=\"ui.preferences_panel_open\" @okButtonClicked=\"ui.preferences_panel_open = false\"/>\n  </div>\n</div>\n    ",
});
//# sourceMappingURL=Sidebar.js.map